export default __webpack_public_path__ + "static/media/nationalIdES.a98e9fb6.jpg";